const NETWORK_ERROR_PATTERNS = [
  /^failed to fetch$/i,
  /^networkerror when attempting to fetch resource\.$/i,
  /network request failed/i,
  /err_internet_disconnected/i,
  /err_network_changed/i,
  /err_connection_refused/i,
  /err_name_not_resolved/i,
  /load failed/i,
];

export const isNetworkConnectionError = error => {
  if (!error) {
    return false;
  }

  if (error.name === 'TypeError' && NETWORK_ERROR_PATTERNS.some(pattern => pattern.test(error.message || ''))) {
    return true;
  }

  const message = error.message || '';
  return NETWORK_ERROR_PATTERNS.some(pattern => pattern.test(message));
};



// WEBPACK FOOTER //
// ./src/helpers/networkError.js